import { Box, InputAdornment, TextField } from "@mui/material"
import { useState } from "react"

import SearchIcon from "@mui/icons-material/Search"
import ClearIcon from "@mui/icons-material/Clear"

import { useSelector } from "react-redux"

const MetricOpportunitySearchFilter = (props: any) => {
  const { handleSearchFn } = props

  const opportunityTableData = useSelector((state: any) => {
    return state.metric.metricOpportunityTableData
  })

  const selectedMetricOpportunityTab = useSelector((state: any) => {
    return state.metric.selectedMetricOpportunityTab
  })

  const [groupNameSearch, setGroupNameSearch] = useState("")

  const groupNameSearchHandler = (value: any) => {
    setGroupNameSearch(value)
    handleSearchFn(opportunityTableData, value, selectedMetricOpportunityTab)
  }

  return (
    <Box sx={{ width: "100%", alignSelf: "center", height: "32px" }}>
      <TextField
        value={groupNameSearch}
        onChange={(e) => groupNameSearchHandler(e.target.value)}
        id="standard-start-adornment"
        placeholder="Search metric"
        sx={{
          backgroundColor: "#FFFFFF",
          // mt: "10px",
          width: "100%",
          height: "100%",
          padding: "0 10px",
          "& .css-mil7nw-MuiInputBase-root-MuiInput-root:before ": {
            borderBottom: "0px",
          },
          "& .css-mil7nw-MuiInputBase-root-MuiInput-root:after ": {
            borderBottom: "0px",
          },
          "& .css-mil7nw-MuiInputBase-root-MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before":
            {
              borderBottom: "0px",
            },
        }}
        InputProps={{
          disableUnderline: true,
          endAdornment:
            groupNameSearch.length > 0 ? (
              <InputAdornment position="end">
                <span onClick={() => groupNameSearchHandler("")}>
                  <ClearIcon
                    sx={{
                      cursor: "pointer",
                      marginRight: "10px",
                      marginTop: "0px",
                    }}
                  />
                </span>
              </InputAdornment>
            ) : (
              ""
            ),
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="standard"
      />
    </Box>
  )
}

export default MetricOpportunitySearchFilter
